import { Text } from '@mantine/core';

import { KeywordRuleForm } from '../../../hooks/useKeywordRuleForm';
import { ChunkPlatform } from '../../../utils/chunk-limits';

import { MessagesFields } from './MessagesFields';

type Props = {
  form: KeywordRuleForm;
  platform: ChunkPlatform;
};

export const Messages = ({ form, platform }: Props) => {
  return (
    <div>
      <Text ta="center" size="md">
        Расклады
      </Text>
      <MessagesFields
        form={form}
        name="spreads"
        placeholder="Текст расклада"
        isRequired
        platform={platform}
      />
      <Text ta="center" size="md">
        При повторном кодовом
      </Text>
      <MessagesFields
        form={form}
        name="repeatedKeyword"
        placeholder="Текст при повторном кодовом"
        isRequired
        platform={platform}
      />
    </div>
  );
};
